var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "form-group",
    },
    [
      _c("input", {
        staticClass: "form-control w-100 text-xl text-center border-success",
        attrs: {
          id: _vm.elementId,
          type: _vm.elementType,
          name: _vm.elementName,
          onfocus: "{ this.value = ''; }",
          placeholder: _vm.elementPlaceholder,
        },
        domProps: {
          value: _vm.amount,
        },
        on: {
          class: _vm.elementClass,
          paste: function ($event) {
            return _vm.onPaste($event)
          },
          keypress: function ($event) {
            return _vm.validateNumber($event)
          },
          keyup: function ($event) {
            return _vm.updateAmount($event)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }